/**
* Category Hero Module
**/

VP = window.VP || {};

(function( $ ) {
	var SELECTOR = {
		video: $('.vp-module__category-hero video')
	};
	VP.categoryHero = {
		window: $(window),
		init: function () {
			var _this = this;

			_this.initCategoryHero();
		},

		initCategoryHero: function() {
			var categoryHeroContainer = $('.vp-module__category-hero__content');
			var lazyloadImage = $('.vp-module__category-hero__media--image', categoryHeroContainer);

			var lazyloadCheck = setInterval(function() {
				if (lazyloadImage.hasClass('lazyloaded')) {
					categoryHeroContainer.addClass('vp-module__category-hero__content--enhanced');
					clearInterval(lazyloadCheck);
				}
			}, 300);
		},
	};
})(jQuery);
